import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { WithdrawalFormValues } from '../components/WithdrawalForm/WithdrawalForm.types';
import { submitWithdrawalForm } from '../services/withdrawal-form.service';
import { WITHDRAWAL_FORM } from '../constants/api';

export interface WithdrawalFormValuesContext {
  previousWithdrawal: WithdrawalFormValues;
}

export type WithdrawalFormValuesVariables = WithdrawalFormValues;

function useMutationSubmitWithdrawalForm(
  onSuccess: (data: any, variables: WithdrawalFormValues, context: WithdrawalFormValuesContext | undefined) => {},
  onError?: (err: any) => any,
): UseMutationResult<string, unknown> {
  const queryClient = useQueryClient();

  const mutationFn = async (formValues: WithdrawalFormValues): Promise<any> => {
    return await submitWithdrawalForm(formValues);
  };

  const onMutateFn = async (): Promise<any> => {
    await queryClient.cancelQueries({ queryKey: [WITHDRAWAL_FORM] });

    return queryClient.getQueryData([WITHDRAWAL_FORM]) as WithdrawalFormValues;
  };

  const onErrorFn = (err: unknown, _id: string, context: WithdrawalFormValuesContext | undefined): void => {
    if (context?.previousWithdrawal !== undefined) {
      queryClient.setQueryData([WITHDRAWAL_FORM], context.previousWithdrawal);
    }
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {
    setTimeout(() => {
      void queryClient.invalidateQueries([WITHDRAWAL_FORM]);
    }, 2000);
  };

  return useMutation<string, unknown, any, any>([WITHDRAWAL_FORM], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess,
  });
}

export default useMutationSubmitWithdrawalForm;
